/* Author : Nitish Hardeniya */
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Reset from '../components/reset';
import * as authActions from '../actions/authActions';

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...authActions,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Reset);
